<form class="register-form" #form="ngForm" (ngSubmit)="confirmSaveItem(itemToSave)" novalidate>

  <!-- Header -->
  <div class="modal-header">
    <h5 class="modal-title">
      {{ (title || '').charAt(0).toUpperCase() + (title || '').slice(1) }}
      <span *ngIf="itemToSave.type_service_codification" class="hgx-badge hgx-badge--info ms-2">
        {{itemToSave.type_service_codification}}
      </span>
    </h5>
    <button type="button" class="btn-close" aria-label="Fermer" (click)="activeModal.dismiss()"></button>
  </div>

  <!-- Tabs nav -->
  <div class="heb-tab-nav px-4">
    <button type="button" class="heb-tab-btn" [class.active]="indice===0" (click)="indice=0">
      <span class="material-icons-outlined">hotel</span>
      Hébergement
    </button>
    <button type="button" class="heb-tab-btn" [class.active]="indice===1" (click)="indice=1"
      *ngIf="!itemToSave.id && hasBoutique">
      <span class="material-icons-outlined">shopping_bag</span>
      Vente boutique
      <span *ngIf="itemsCommandeDetailToSave.length > 0" class="heb-badge">
        {{ itemsCommandeDetailToSave.length }}
      </span>
    </button>
  </div>

  <div *ngIf="indice===0" class="modal-body cr-body">
    <section class="cr-section">
      <h6>Client</h6>
      <div class="cr-grid">
      <div class="cr-field cr-span-2">
        <div class="cr-label-row"><span class="form-label">Client</span><button type="button" class="cr-link" (click)="openAddClientModal('add')"><i class="material-icons-outlined" aria-hidden="true">person_add</i>Nouveau client</button></div>
        <app-client-search-select name="client_id" [hotelId]="user.hotel_id" [groupeId]="user.groupe_id"
          [userId]="user.id" [value]="itemToSave.client_id"
          (clientChange)="itemToSave.client_id = $event?.id; onClientChange($event)">
        </app-client-search-select>
        <div class="text-danger small" *ngIf="form.submitted && !itemToSave.client_id">Client est requis</div>

      </div>
      <div class="cr-field cr-span-2">
        <div class="cr-label-row"><span class="form-label">Apporteur <span class="cr-optional">(facultatif)</span></span><button type="button" class="cr-link" (click)="openAddApporteurModal('add')"><i class="material-icons-outlined" aria-hidden="true">person_add</i>Nouvel apporteur</button></div>
        <app-apporteur-search-select name="apporteur_id" [hotelId]="user.hotel_id" [groupeId]="user.groupe_id"
          [userId]="user.id" [value]="itemToSave.apporteur_id" (apporteurChange)="itemToSave.apporteur_id = $event?.id">
        </app-apporteur-search-select>

      </div>
      <div class="cr-field" *ngIf="queueCount>0 && itemToSave.type_service_codification == 'PASS'">
        <label class="form-label">File d'attente</label>
        <select (change)="onSelectFileAttente()" class="form-select" name="client_idFileAttente"
          [(ngModel)]="itemToSave.client_idFileAttente">
          <option value=""></option>
          <option *ngFor="let item of itemsFileAttenteHebergement" [value]="item.id">
            {{ item.client_nom }} {{ item.client_prenom }}/{{ item.client_telephone }}
          </option>
        </select>
      </div>
      </div>
    </section>
    <section class="cr-section">
      <h6>Séjour</h6>
      <div class="cr-grid">
      <div class="cr-field">
        <label class="form-label">Formule</label>
        <select [disabled]="itemToSave.type_service_codification" class="form-select" name="service_id"
          [(ngModel)]="itemToSave.service_id" #service="ngModel" (change)="onSelectService()">
          <option *ngFor="let item of itemsService" [value]="item.id">{{ item.libelle }}</option>
        </select>
        <div class="text-danger small" *ngIf="service.invalid && service.touched">Service est requis</div>
      </div>
      <div class="cr-field">
        <div class="cr-label-row"><span class="form-label">Chambre</span><button type="button" class="cr-link" (click)="getitemsChambre()"><i class="material-icons-outlined" aria-hidden="true">search</i>Disponibilités</button></div>
        <select class="form-select" name="chambre_id" [(ngModel)]="itemToSave.chambre_id" required
          #chambre_idCtrl="ngModel" (change)="calculatePrice()">
          <option value=""></option>
          <option *ngFor="let item of itemsChambre" [value]="item.id">
            {{ item.libelle }} / {{ item.montant_service | IntegerFormatPipe }}
          </option>
        </select>
        <div class="text-danger small" *ngIf="chambre_idCtrl.invalid && chambre_idCtrl.touched">Chambre est requise
        </div>
      </div>
      <div class="cr-field" *ngIf="current_service && current_service.codification=='PASS'">
        <label class="form-label">Nombre d'heures</label>
        <input (keyup)="onSetDateTimeBasedOnDuration()" type="number" class="form-control"
          [(ngModel)]="itemToSave.duree_heures" name="duree_heures" #duree_heuresCtrl="ngModel" required />
        <div class="text-danger small" *ngIf="duree_heuresCtrl.invalid && duree_heuresCtrl.touched">
          Nombre d'heure est réquis
        </div>
      </div>
      <!-- PASS : horaire sur une seule ligne -->
      <div class="cr-field" *ngIf="current_service && current_service.codification=='PASS'">
        <label class="form-label">Horaire</label>
        <div class="cr-range">
          <input disabled (change)="onSetDurationBasedOnTime();" type="time" class="form-control"
            [(ngModel)]="itemToSave.heure_debut" name="heure_debut" aria-label="Heure début" />
          <span aria-hidden="true">→</span>
          <input disabled (change)="onSetDurationBasedOnTime(); onSetHeure()" type="time" class="form-control"
            [(ngModel)]="itemToSave.heure_fin" name="heure_fin" aria-label="Heure fin" />
        </div>
      </div>
      <!-- Nuitée, journée, séjour : date (et heure) de début puis de fin -->
      <ng-container *ngIf="current_service && current_service.codification !='PASS'">
        <div class="cr-field">
          <label class="form-label">Début</label>
          <div [class.cr-datetime]="current_service.codification !='SEJOUR'">
            <input autocomplete="off" type="text" disabled class="form-control" [(ngModel)]="itemToSave.date_debut"
              bsDatepicker name="date_debut" #date_debutCtrl="ngModel" required (bsValueChange)="onSelectDateDebut($event)"
              [bsConfig]="datePickerConfig" aria-label="Date début" />
            <input *ngIf="current_service.codification !='SEJOUR'" disabled (change)="onSetDurationBasedOnTime();"
              type="time" class="form-control" [(ngModel)]="itemToSave.heure_debut" name="heure_debut" aria-label="Heure début" />
          </div>
          <div class="text-danger small" *ngIf="date_debutCtrl.invalid && date_debutCtrl.touched">Date début est requise
          </div>
        </div>
        <div class="cr-field">
          <label class="form-label">Fin</label>
          <div [class.cr-datetime]="current_service.codification !='SEJOUR'">
            <input autocomplete="off" [disabled]="current_service.codification != 'SEJOUR'" class="form-control"
              [(ngModel)]="itemToSave.date_fin" name="date_fin" #date_finCtrl="ngModel" required
              (bsValueChange)="onSelectDateFin($event)" bsDatepicker [(bsValue)]="myDate" [bsConfig]="datePickerConfig"
              aria-label="Date fin" />
            <input *ngIf="current_service.codification !='SEJOUR'" disabled (change)="onSetDurationBasedOnTime(); onSetHeure()"
              type="time" class="form-control" [(ngModel)]="itemToSave.heure_fin" name="heure_fin" aria-label="Heure fin" />
          </div>
          <div class="text-danger small" *ngIf="date_finCtrl.invalid && date_finCtrl.touched">Date fin est requise</div>
        </div>
      </ng-container>
      </div>
    </section>
    <section class="cr-section">
      <h6>Montant</h6>
      <div class="cr-grid cr-grid--3">
      <div class="cr-field">
        <label class="form-label">Total <span class="cr-optional">(calculé)</span></label>
        <div class="cr-amount"><input disabled type="text" appMontant class="form-control" [(ngModel)]="itemToSave.montant_total" name="montant_total"
          #montant_totalCtrl="ngModel" required /><span>FCFA</span></div>
      </div>
      <div class="cr-field" *ngIf="itemToSave.type_service_codification !== 'PASS'">
        <label class="form-label">Avance</label>
        <div class="cr-amount"><input [disabled]="itemToSave.type_service_codification == 'PASS'" type="text" appMontant class="form-control"
          [ngModel]="itemToSave.montant_avance" (ngModelChange)="itemToSave.montant_avance = $event; onCalculateMonnaie()" name="montant_avance" #montant_avanceCtrl="ngModel"
          required /><span>FCFA</span></div>
        <div class="text-danger small" *ngIf="montant_avanceCtrl.invalid && montant_avanceCtrl.touched">Avance requise
        </div>
      </div>
      <div class="cr-field" *ngIf="itemToSave.client_idFileAttente">
        <label class="form-label">Avance file attente</label>
        <div class="cr-amount"><input type="text" appMontant class="form-control" [ngModel]="itemToSave.montant_avance_file_attente" (ngModelChange)="itemToSave.montant_avance_file_attente = $event; onCalculateMonnaie()"
          name="montant_avance_file_attente" /><span>FCFA</span></div>
      </div>
      <div class="cr-field" *ngIf="itemToSave.client_idFileAttente">
        <label class="form-label">Reste à régler</label>
        <div class="cr-amount"><input type="text" appMontant class="form-control" [ngModel]="itemToSave.montant_restant_file_attente" (ngModelChange)="itemToSave.montant_restant_file_attente = $event; onCalculateMonnaie()"
          name="montant_restant_file_attente" /><span>FCFA</span></div>
      </div>
      <div class="cr-field" *ngIf="itemToSave.client_idFileAttente">
        <label class="form-label">Montant à ristourner</label>
        <div class="cr-amount"><input type="text" appMontant class="form-control" [ngModel]="itemToSave.montant_ristourne_file_attente" (ngModelChange)="itemToSave.montant_ristourne_file_attente = $event; onCalculateMonnaie()"
          name="montant_ristourne_file_attente" /><span>FCFA</span></div>
      </div>
      <div class="cr-field" *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
        <label class="form-label">Mode règlement</label>
        <select class="form-select" [(ngModel)]="itemToSave.mode_reglement_id" name="mode_reglement_id" required>
          <option value="" disabled selected>--</option>
          <option *ngFor="let item of itemsModeReglement" [value]="item.id"
            [disabled]="item.codification === 'FIDELITY' && !canUseFidelity()">
            {{ item.libelle }}
            <ng-container *ngIf="item.codification === 'FIDELITY' && clientFidelite">
              ({{ clientFidelite.montant_equivalent ?? 0 }} disponible)
            </ng-container>
          </option>
        </select>
      </div>
      <div class="cr-field" *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
        <label class="form-label">Caisse</label>
        <select class="form-select" [(ngModel)]="itemToSave.caisse_id" name="caisse_id" required>
          <option *ngFor="let item of itemsUserCaisse" [value]="item.caisse_id">{{ item.caisse_libelle }}</option>
        </select>
      </div>
      <div class="cr-field"
        *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id && !itemToSave.montant_ristourne_file_attente">
        <label class="form-label">Montant reçu</label>
        <div class="cr-amount"><input type="text" appMontant class="form-control" [ngModel]="itemToSave.montant_recu" (ngModelChange)="itemToSave.montant_recu = $event; onCalculateMonnaie()" name="montant_recu"
          required /><span>FCFA</span></div>
      </div>
      <div class="cr-field"
        *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id && !itemToSave.montant_ristourne_file_attente">
        <label class="form-label">Monnaie rendue</label>
        <div class="cr-amount"><input type="text" appMontant class="form-control" [(ngModel)]="itemToSave.monnaie_rendue" name="monnaie_rendue" /><span>FCFA</span></div>
      </div>
      <div class="cr-field" *ngIf="itemToSave.montant_avance > 0 && !itemToSave.id">
        <label class="form-label">Référence règlement</label>
        <input type="text" class="form-control" [(ngModel)]="itemToSave.reference_reglement"
          name="reference_reglement" autocomplete="off" />
      </div>
      </div>
    </section>
  </div>

  <!-- Onglet 2 : vente directe boutique -->
  <div *ngIf="hasBoutique && indice===1 && !itemToSave.id" class="modal-body vb">
    <div class="vb-toolbar">
      <label class="vb-field vb-field--grow">
        <span class="form-label">Rechercher</span>
        <input type="search" class="form-control" [(ngModel)]="article_search" name="article_search"
          placeholder="Nom de l'article">
      </label>
    </div>

    <div class="vb-layout">
      <section class="vb-panel" aria-labelledby="vb-catalogue">
        <div class="vb-panel-head">
          <h6 id="vb-catalogue">Catalogue <small class="vb-hint">· stock tous magasins</small></h6>
          <span class="hgx-badge">{{ filteredArticles.length }}</span>
        </div>
        <ul class="vb-catalogue">
          <li *ngFor="let a of filteredArticles">
            <button type="button" class="vb-article" [class.vb-article--in]="isInCart(a)"
              [disabled]="!(a.quantite_en_stock > 0)" (click)="addToCart(a)"
              [attr.aria-label]="'Ajouter ' + a.libelle + ' au panier'">
              <img *ngIf="a.image_url; else initiale" [src]="a.image_url" alt="" class="vb-thumb" />
              <ng-template #initiale><span class="vb-thumb vb-thumb--initiale" aria-hidden="true">{{ (a.libelle || '?').charAt(0) }}</span></ng-template>
              <span class="vb-article-text">
                <strong [title]="a.libelle">{{ a.libelle }}</strong>
                <span [class.vb-stock-bas]="a.quantite_en_stock <= 3">
                  {{ a.quantite_en_stock > 0 ? a.quantite_en_stock + ' en stock' : 'Rupture' }}
                </span>
              </span>
              <span class="vb-price hgx-num">{{ a.prix_vente | IntegerFormatPipe }}</span>
              <span class="vb-add" aria-hidden="true">
                <ng-container *ngIf="isInCart(a); else plus">{{ getCartQty(a) }}</ng-container>
                <ng-template #plus><i class="material-icons-outlined">add</i></ng-template>
              </span>
            </button>
          </li>
        </ul>
        <p *ngIf="filteredArticles.length === 0" class="vb-empty">Aucun article trouvé</p>
      </section>

      <section class="vb-panel" aria-labelledby="vb-panier">
        <div class="vb-panel-head">
          <h6 id="vb-panier">Panier</h6>
          <span class="hgx-badge" [class.hgx-badge--info]="itemsCommandeDetailToSave.length">
            {{ itemsCommandeDetailToSave.length }} article{{ itemsCommandeDetailToSave.length > 1 ? 's' : '' }}
          </span>
        </div>

        <div *ngIf="itemsCommandeDetailToSave.length === 0" class="vb-empty vb-empty--panier">
          <i class="material-icons-outlined" aria-hidden="true">shopping_cart</i>
          <p>Choisissez des articles dans le catalogue</p>
        </div>

        <ul *ngIf="itemsCommandeDetailToSave.length > 0" class="vb-cart">
          <li *ngFor="let item of itemsCommandeDetailToSave; let i = index">
            <span class="vb-cart-name">
              <strong>{{ item.article_libelle }}</strong>
              <span class="hgx-num">{{ item.prix | IntegerFormatPipe }} l'unité</span>
            </span>
            <span class="vb-qty">
              <button type="button" aria-label="Retirer une unité"
                (click)="item.quantite = item.quantite - 1; onCartQtyChange(item, i)">
                <i class="material-icons-outlined" aria-hidden="true">remove</i>
              </button>
              <input type="number" min="1" [(ngModel)]="item.quantite" [name]="'cart_qty_' + i"
                (change)="onCartQtyChange(item, i)" aria-label="Quantité">
              <button type="button" aria-label="Ajouter une unité"
                (click)="item.quantite = item.quantite + 1; onCartQtyChange(item, i)">
                <i class="material-icons-outlined" aria-hidden="true">add</i>
              </button>
            </span>
            <span class="vb-cart-total hgx-num">{{ item.total | IntegerFormatPipe }}</span>
            <button type="button" class="vb-remove" (click)="removeFromCart(i)" aria-label="Retirer l'article">
              <i class="material-icons-outlined" aria-hidden="true">close</i>
            </button>
          </li>
        </ul>

        <div *ngIf="itemsCommandeDetailToSave.length > 0" class="vb-total">
          <span>Total</span>
          <strong class="hgx-num">{{ cartTotal | IntegerFormatPipe }} FCFA</strong>
        </div>
      </section>
    </div>
  </div>

  <div class="modal-footer cr-footer">
    <label for="hebergement-image" class="cr-attach">
      <img *ngIf="imageDisplay" [src]="imageDisplay" alt="Aperçu de la pièce jointe" />
      <i *ngIf="!imageDisplay" class="material-icons-outlined" aria-hidden="true">attach_file</i>
      {{ imageDisplay ? "Remplacer l'image" : 'Joindre une image' }}
    </label>
    <input hidden id="hebergement-image" type="file" accept=".png, .jpg, .jpeg, .bmp" (change)="uploadFile($event)" />
    <span class="cr-hint" *ngIf="itemsCommandeDetailToSave.length > 0">{{ itemsCommandeDetailToSave.length }} article(s) · {{ cartTotal | IntegerFormatPipe }} FCFA</span>
    <span class="cr-hint" *ngIf="form.invalid || !itemToSave.client_id">Renseignez les champs obligatoires pour enregistrer.</span>
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Annuler</button>
    <button type="submit" class="btn btn-primary" [disabled]="form.invalid || !itemToSave.client_id">Enregistrer l'hébergement</button>
  </div>
</form>
